export const getUserLocale = () => window.navigator.language || 'en-GB';
